import { ICellRendererParams } from 'ag-grid-community';

import { BomPartType } from 'bom/enums';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Price } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';

interface IProps extends ICellRendererParams {
  treatAsCost?: boolean;
}

const ExtendedPriceCell = ({ treatAsCost = false, ...props }: IProps) => {
  const data = getAgGridTableCellData(props, QuotePartColId.EXT_PRICE);

  if (!props.value || data?.type === BomPartType.DISCOUNT) {
    return DEFAULT_PLACEHOLDER;
  }

  // Always the line's PRICE decimals: this column extends `quote_part.price`, which the BE
  // rounds by price decimals regardless of the quote being a vendor one. `treatAsCost` only
  // says to pad to a fixed width, not which precision to round at.
  return (
    <Price amount={props.value} decimals={data?.quotePriceDecimals} fixedDecimals={treatAsCost} />
  );
};

export default ExtendedPriceCell;
